import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBox12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconBox12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Box12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M5.33 11.665a1.5 1.5 0 0 0 1.34 0l4.777-2.389A1 1 0 0 0 12 8.382V3.927a1.5 1.5 0 0 0-.83-1.342L6.895.447a2 2 0 0 0-1.788 0L.829 2.585A1.5 1.5 0 0 0 0 3.927v4.455a1 1 0 0 0 .553.894zM1.275 8.52A.5.5 0 0 1 1 8.073v-3.61a.25.25 0 0 1 .362-.223l3.862 1.93a.5.5 0 0 1 .276.448v3.61a.25.25 0 0 1-.362.223zm.848-5.464a.25.25 0 0 0 0 .447L5.776 5.33a.5.5 0 0 0 .448 0l3.652-1.826a.25.25 0 0 0 0-.447L6.224 1.23a.5.5 0 0 0-.448 0zm8.514 1.184a.25.25 0 0 1 .362.224v3.609a.5.5 0 0 1-.276.447l-3.862 1.931a.25.25 0 0 1-.362-.224V6.618a.5.5 0 0 1 .276-.447z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Box12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconBox12);
